interface NavigationItem {
  id: string;
  label: string;
}

interface HomepageNavigationProps {
  items?: NavigationItem[];
}

const defaultNavItems: NavigationItem[] = [
  { id: "wie-funktioniert", label: "Wie funktioniert eine Kreditkarte?" },
  { id: "vorteile", label: "Vorteile & Leistungen" },
  { id: "reisen", label: "Reisekreditkarten & Ausland" },
  { id: "so-finden", label: "So finden Sie die beste Karte" },
  { id: "faq", label: "Häufige Fragen (FAQ)" },
];

export const HomepageNavigation = ({ items = defaultNavItems }: HomepageNavigationProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 80; // Account for sticky header
      const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: elementPosition - offset,
        behavior: 'smooth'
      });
    }
  };

  return (
    <nav 
      aria-label="Seiten-Navigation" 
      className="bg-muted/30 rounded-lg p-4 mb-12 border border-border"
    >
      <ul className="flex flex-wrap gap-3 justify-center">
        {items.map((item) => (
          <li key={item.id}>
            <a
              href={`#${item.id}`}
              onClick={(e) => handleClick(e, item.id)}
              className="inline-block px-4 py-2 rounded-md bg-background border border-border hover:border-primary hover:bg-primary/5 transition-colors text-sm font-medium"
              aria-label={`Springe zu ${item.label}`}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
};
